import { Component, Input } from '@angular/core';
import { Sort } from '@angular/material';
import { LrsList } from '../../../../../../model/finzy-flex/lrs-list.model';

@Component({
    selector: 'app-report-table',
    templateUrl: './report-table.component.html',
    styleUrls: ['./report-table.component.scss'],
})
export class ReportTableComponent {
    @Input() lrsReportList: LrsList;

    public sortColumn(sort: Sort) {
        const data = this.lrsReportList.data.slice();
        if (!sort.active || sort.direction === '') {
            this.lrsReportList.data = data;
            return;
        }
    
        this.lrsReportList.data = data.sort((currentValue, nextValue) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'frequencyValue':
                    return this.compare(currentValue.frequencyValue, nextValue.frequencyValue, isAsc);
                case 'investmentAmount':
                    return this.compare(currentValue.investmentAmount, nextValue.investmentAmount, isAsc);
                case 'nCashAmount':
                    return this.compare(currentValue.nCashAmount, nextValue.nCashAmount, isAsc);
                case 'withdrawalAmount':
                    return this.compare(currentValue.withdrawalAmount, nextValue.withdrawalAmount, isAsc);
                case 'interestAmount':
                    return this.compare(currentValue.interestAmount, nextValue.interestAmount, isAsc);
                case 'creditLoss':
                    return this.compare(currentValue.creditLoss, nextValue.creditLoss, isAsc);
                case 'principalOutstanding':
                    return this.compare(currentValue.principalOutstanding, nextValue.principalOutstanding, isAsc);
                default:
                    return 0;
            }
        });
    }
    
    private compare(currentValue: number | string, nextValue: number | string, isAsc: boolean) {
      return (currentValue < nextValue ? -1 : 1) * (isAsc ? 1 : -1);
    }
}